import { useFetchExams } from "src/redux/api/hooks/useFetchExams";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "./table";
import { convertDateToIST, convertTimeToIST } from "src/lib/utils";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "./button";

const LoadingSkeleton = () => (
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead className="w-64 md:text-xl">Post</TableHead>
        <TableHead className="w-64 text-end md:text-xl">Date & Time</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {[...Array(5)].map((_, index) => (
        <TableRow key={index}>
          <TableCell className="h-6 w-64 animate-pulse bg-gray-200 md:text-xl"></TableCell>
          <TableCell className="h-6 w-64 animate-pulse bg-gray-200 text-end md:text-xl"></TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export const Exams = () => {
  const { scheduledExams, isPending } = useFetchExams();
  const navigate = useNavigate();

  if (isPending) {
    return <LoadingSkeleton />;
  }

  return (
    <div>
      <h1 className="px-2 py-4 text-xl font-bold text-center">Your Exams</h1>
      {
        scheduledExams?.length !== 0 && 
        <Link to="/applied-posts" className="text-primary animate-pulse">
          <p className="text-center mb-3">Click Here to View Your Admit Card</p> 
        </Link>
      }
      
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className=" md:text-md">Post</TableHead>
            <TableHead className=" text-center md:text-md">
              Date & Time
            </TableHead>
            <TableHead className="md:text-md text-center">Exam Status</TableHead>
            <TableHead className="md:text-md text-center">Qualifying Mark</TableHead>
            <TableHead className="md:text-md text-center">Mark Scored</TableHead>
            <TableHead className="md:text-md text-center">Result</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {scheduledExams.length === 0 && (
            <>
              <TableCell className="font-semibold md:text-xl text-center py-6" colSpan={12}>No exams available</TableCell>
            </>
          )}
          {scheduledExams.map(({ exam, isExamCloseForPost, isMissed, result }) => (
            <TableRow key={exam.id} className="mt-2">
              <TableCell className="md:text-md">{exam.postName}</TableCell>
              <TableCell className="text-center md:text-md">
                {convertDateToIST(new Date(exam.slot.date).toUTCString())} -{" "}
                {convertTimeToIST(exam.slot.startTime)}
              </TableCell>
              <TableCell className="text-center">
                {exam.status.toLowerCase() === "appeared" ? (
                      <span className="text-md font-medium uppercase text-green-500">
                      Appeared
                    </span>                  
                ) : isMissed ? (
                  <span className="text-md font-medium uppercase text-red-500">
                    Exam Missed
                  </span>
                ) : exam.status.toLowerCase() === "terminated" ? (
                  <span className="text-md font-medium uppercase text-red-500">
                    TERMINATED
                  </span>
                ) : (
                  <Button
                    onClick={() => {
                      isExamCloseForPost && 
                        navigate(`/start?admit=${exam.admitCardNumber}`);
                    }}
                    variant={isExamCloseForPost ? "default" : "secondary"}
                    disabled={!isExamCloseForPost}
                  >
                    Start Exam
                  </Button>
                )}
              </TableCell>
              {
                result?.publish && (
                  <>
                    <TableCell className="text-lg font-medium uppercase text-center">{result.qualified_marks}</TableCell>
                    <TableCell className="text-lg font-medium uppercase text-center">{result.marks}</TableCell>
                    <TableCell className={ `${result.result.toLowerCase() === "not qualified" ? "text-red-500" : "text-green-500" } text-lg font-medium uppercase text-center`}>{result.result}</TableCell>
                  </>
                )
              }
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
